// Polyfills for Vite compatibility
if (typeof global === 'undefined') {
  (window as any).global = window;
}

// Ensure moment is available globally if needed
import moment from 'moment';
(window as any).moment = moment;